import React, { useContext, useState } from "react";
import { faGlobeAfrica, faHomeAlt, faImage, faPlane, faSearch, faBars, faClose, faBlog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../services/languages.context";
import { content } from "../../_helpers/translation";
import { HoverAnimButton } from "../buttons/hover-anim/hover-anim";

export const HeaderNav = () => {

    const navigateTo = useNavigate();
    const [term, setTerm] = useState('');
    const [showNav, navSetShowNav] = useState(false);

    const { appLanguage } = useContext(LanguageContext);

    const toggleNav = () => navSetShowNav((v) => !v);

    const isThispage = (url) => window.location.pathname === url;

    const { header } = content;
    const { home, services, gallery, visa } = header;


    return (
        <nav className={classNames("app-nav", "rw-al-cnt")}>
            <button 
                className={classNames("tr-btn","nav-bars")}
                onClick={toggleNav}
            >
                <FontAwesomeIcon icon={faBars} className="ttl" />
            </button>
            <div 
                className= {classNames(
                    "nav-section",
                    { "shown": showNav }
                )}

            >
                <div className="close-box">
                    <button 
                        className={classNames("tr-btn", "ttl")}
                        onClick={toggleNav} 
                    >
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
                <div className={classNames("app-img","mobi-nav-image", "hv-5" )}>
                    <img src="/app-images/uest-logo.png" className="app-logo" alt=""/>
                </div>
                <HoverAnimButton 
                    navTo={() => navigateTo("/")}
                    icon={faHomeAlt}
                    caption={home[appLanguage]}
                    path={isThispage("/")}
                />
                <HoverAnimButton 
                    navTo={() => navigateTo("/services")}
                    icon={faGlobeAfrica}
                    caption={services[appLanguage]}
                    path={isThispage("/services")}
                />
                <HoverAnimButton 
                    navTo={() => navigateTo("/blog")}
                    icon={faBlog}
                    caption={"Blog"}
                    path={isThispage("/blog")}
                />
                <HoverAnimButton 
                    navTo={() => navigateTo("/visa-programs")}
                    icon={faPlane}
                    caption={visa[appLanguage]}
                    path={isThispage("/visa-programs")}
                />
                <HoverAnimButton 
                    navTo={() => navigateTo("/gallery")}
                    icon={faImage}
                    caption={gallery[appLanguage]}
                    path={isThispage("/gallery")}
                />

            </div>
            <form className={classNames("search-form", "hs-4")}>
                <div className={classNames("input-container", "rw-al-cnt")}>
                    <input 
                        className="search-input" 
                        type="search" 
                        value={term}
                        onChange={(e) => setTerm(e.target.value)} 
                    />
                    <button 
                        className={classNames("tr-btn","rw-al-cnt")}
                        onClick={(e) => {
                            e.preventDefault();
                        }}
                    >
                        <FontAwesomeIcon icon={faSearch} className="ttl" />
                    </button>
                </div>
            </form>
        </nav>
    )
}